import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(5),
    textAlign: "center",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(2),
    },
    [theme.breakpoints.down("lg")]: {
      marginTop: theme.spacing(5),
    },
  },
  root: {
    display: "flex",
    color: theme.palette.primary.contrastText,
    paddingTop: theme.spacing(3),
    minHeight: "100vh",
    background: `url("/fruition-icon-background.svg") repeat center center fixed;`,
  },
  ribbonImage: {
    position: "absolute",
    width: "20%",
    height: "150px !important",
    maxWidth: "250px !important",
    maxHeight: "150px !important",
    right: 0,
    left: 0,
    marginLeft: "auto",
    marginRight: "auto",
    [theme.breakpoints.only("xs")]: {
      top: theme.spacing(-9),
    },
    [theme.breakpoints.only("sm")]: {
      top: theme.spacing(-9),
    },
    [theme.breakpoints.only("md")]: {
      top: theme.spacing(-8),
    },
    [theme.breakpoints.up("lg")]: {
      top: theme.spacing(-8),
    },
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    paddingBottom: 20,
  },
  top: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(2),
  },
  bottom: {
    width: "100%", // Fix IE 11 issue.
    marginBottom: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formWrapper: {
    width: "100%",
    maxWidth: 520,
    padding: "0 40px",
  },
  loginContent: {
    background: `url("/fruition-icon-background.svg") repeat center center fixed;`,
    minHeight: "100VH",
    width: "100%",
    paddingTop: theme.spacing(3),
  },
  wrapperLogin: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  logo: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: 45,
    marginTop: 85,
    width: "100%",
    maxWidth: 276,
    [theme.breakpoints.down("sm")]: {
      marginTop: 14,
      width: "80%",
      marginBottom: 27,
    },
  },
  character2: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    width: "100%",
    maxWidth: 300,
    marginBottom: 3,
  },
  loginLeftContent: {
    backgroundColor: "transparent",
    minHeight: "85VH",
    height: "100%",
    width: "50%",
    marginTop: 0,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "32px 0",
      width: "100%",
      minHeight: "90VH",
    },
  },
  testimonialsContainer: {
    [theme.breakpoints.up("md")]: {
      marginTop: -100,
    },
  },
  loginRightContent: {
    width: "50%",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      padding: "32px 0",
      minHeight: "100VH",
      width: "100%",
    },
  },
  blue: {
    color: "#6199BE",
  },
  bold: {
    fontWeight: 600,
  },
  large: {
    fontSize: 14,
  },
}));

export default useStyles;
